<template>
  <div v-if="!operatorsArray.includes(operator)" :class="name">
    <b-field :label="label">
      <the-mask
        class="input"
        :mask="formatMask"
        placeholder="Digite as datas"
        @input="set"
        :value="currentValue"
        :disabled="disabled"
        :operator="operator"
        :format="format"
      />
    </b-field>
  </div>
  <div v-else :class="`${name} between`">
    <b-field :label="label">
      <the-mask v-for="({ placeholder, position }, key) in between" :key="key"
        class="input"
        :mask="formatMask"
        :placeholder="placeholder"
        @input="($event) => set($event, position)" 
        :value="currentValue[position]"
        :disabled="disabled"
        :operator="operator"
        :format="format"
      />
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'InputDate',
  data: () => ({
    operatorsArray: ['bt', 'nbt'],
    between: [
      {
        placeholder: 'de',
        position: 0
      },
      {
        placeholder: 'até',
        position: 1
      }
    ]
  }),
  props: {
    name: {
      type: String,
      default: () => ''
    },
    formatMask: {
      type: String,
      default: () => ''
    },
    operator: {
      type: String,
      default: () => ''
    },
    format: {
      type: String,
      default: () => ''
    },
    currentValue: {
      type: [String, Array],
      default: () => ''
    },
    label: {
      type: String,
      default: () => null
    },
    handler: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    groupIndex: {
      type: Number,
      default: () => null
    },
    index: {
      type: Number,
      default: () => null
    }
  },
  methods: {
    set(value, position = false) {
      const { groupIndex, index, handler, name, currentValue, getNewArray } = this
      if (position !== false) value = getNewArray(currentValue, value, position)
      this.$emit('set', { name, value, groupIndex, index, handler })
    },
    getNewArray(old, value, position) {
      if (!(old instanceof Array)) old = []
      old[position] = value
      return old
    }
  },
  watch: {
    operator: {
      immediate: false,
      deep: true,
      handler (value) {
        if (['bt', 'nbt'].includes(value)) {
          this.currentValue = ['', '']
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .has-addons {
    display: flex;
    flex-direction: column;
    input {
      &:last-child {
        margin-top: 12px;
      }
    }
    .is-clearfix {
      &:first-child {
        margin-top: -10px;
      }
    }
  }
</style>
